    import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import {
  FiCalendar,
  FiChevronRight,
} from "react-icons/fi";

const WEEK_DAYS = [
  "Su",
  "Mo",
  "Tu",
  "We",
  "Th",
  "Fr",
  "Sa",
];

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const getMonthInfo = (offset = 0) => {
  const now = new Date();

  const date = new Date(
    now.getFullYear(),
    now.getMonth() + offset,
    1
  );

  return {
    year: date.getFullYear(),
    month: date.getMonth(),
  };
};

const formatSalaryDate = (day, month, year) => {
  const dd = String(day).padStart(2, "0");
  const mm = String(month + 1).padStart(2, "0");
  const yy = String(year).slice(-2);

  return `${dd}${mm}${yy}`;
};

const formatSalaryDateDisplay = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");

  if (digits.length !== 6) {
    return raw || "";
  }

  return `${digits.slice(0, 2)}/${digits.slice(
    2,
    4
  )}/${digits.slice(4, 6)}`;
};

const FwDayCalendar = ({
  id,
  label,
  value,
  placeholder,
  openKey,
  setOpenKey,
  onChange,

  // MONTH_NAMES,
  // WEEK_DAYS,
  // getMonthInfo,
  // formatSalaryDate,
  // formatSalaryDateDisplay,
}) => {
  const rootRef = useRef(null);

  const isOpen = openKey === id;

  const [monthOffset, setMonthOffset] =
    useState(0);

  const { year, month } =
    getMonthInfo(monthOffset);

  const daysInMonth =
    new Date(
      year,
      month + 1,
      0
    ).getDate();

  const startWeekday =
    new Date(
      year,
      month,
      1
    ).getDay();

  const blanks = Array.from(
    { length: startWeekday },
    (_, i) => `b-${i}`
  );

  const days = Array.from(
    { length: daysInMonth },
    (_, i) => i + 1
  );

  const today = new Date();

  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutside = (event) => {
      if (
        rootRef.current &&
        !rootRef.current.contains(
          event.target
        )
      ) {
        setOpenKey(null);
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutside
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        handleOutside
      );
  }, [isOpen, setOpenKey]);

  useEffect(() => {
    if (isOpen) {
      setMonthOffset(0);
    }
  }, [isOpen]);

  return (
    <div
      className="fw-field"
      ref={rootRef}
    >
      <span>{label}</span>

      <div
        className={`fw-daycal ${
          isOpen ? "is-open" : ""
        }`}
      >
        <button
          type="button"
          className={`fw-daycal__trigger ${
            !value ? "is-placeholder" : ""
          }`}
          aria-expanded={isOpen}
          onClick={() =>
            setOpenKey(
              isOpen ? null : id
            )
          }
        >
          <span>
            {value
              ? formatSalaryDateDisplay(
                  value
                )
              : placeholder}
          </span>

          <FiCalendar />
        </button>

        {isOpen && (
          <div
            className="fw-daycal__panel"
            role="listbox"
            aria-label="Select salary date"
          >
            <div className="fw-daycal__head">
              <button
                type="button"
                className="fw-daycal__nav"
                aria-label="Previous month"
                disabled={
                  monthOffset <= 0
                }
                onClick={() =>
                  setMonthOffset(0)
                }
              >
                <FiChevronRight
                  style={{
                    transform:
                      "rotate(180deg)",
                  }}
                />
              </button>

              <strong>
                {MONTH_NAMES[month]}{" "}
                {year}
              </strong>

              <button
                type="button"
                className="fw-daycal__nav"
                aria-label="Next month"
                disabled={
                  monthOffset >= 1
                }
                onClick={() =>
                  setMonthOffset(1)
                }
              >
                <FiChevronRight />
              </button>
            </div>

            <div className="fw-daycal__week">
              {WEEK_DAYS.map((d) => (
                <span key={d}>
                  {d}
                </span>
              ))}
            </div>

            <div className="fw-daycal__grid">
              {blanks.map((key) => (
                <span
                  key={key}
                  className="fw-daycal__blank"
                />
              ))}

              {days.map((day) => {
                const formatted =
                  formatSalaryDate(
                    day,
                    month,
                    year
                  );

                const cellDate =
                  new Date(
                    year,
                    month,
                    day
                  );

                cellDate.setHours(
                  0,
                  0,
                  0,
                  0
                );

                const isPast =
                  monthOffset === 0 &&
                  cellDate < today;

                return (
                  <button
                    key={`${month}-${day}`}
                    type="button"
                    role="option"
                    aria-selected={
                      value === formatted
                    }
                    disabled={isPast}
                    className={`fw-daycal__day ${
                      value === formatted
                        ? "is-active"
                        : ""
                    } ${
                      isPast
                        ? "is-disabled"
                        : ""
                    }`}
                    onClick={() => {
                      if (isPast) return;

                      onChange(
                        formatted
                      );

                      setOpenKey(null);
                    }}
                  >
                    {day}
                  </button>
                );
              })}
            </div>

            <p className="fw-daycal__hint">
              DDMMYY · From today onwards
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FwDayCalendar;